import { render, staticRenderFns } from "./FamilyTypesIndex.vue?vue&type=template&id=3cb364bc&"
import script from "./FamilyTypesIndex.vue?vue&type=script&lang=js&"
export * from "./FamilyTypesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports